import React from "react"

export default function Index() {
	return (
		<div className="page404">
			<div>404</div>
			<div>PAGE NOT FOUND</div>
		</div>
	)
}
